<script lang="ts">
  import { getTimeLabel } from '../utils/format-time';

  export let duration: number;
  export let currentTime: number;
</script>

<div {...$$restProps} role="timer" class="timer">
  <span class="timer__value" style="width: {(100 * currentTime) / duration}%">
    {getTimeLabel(currentTime)} von {getTimeLabel(duration)}
  </span>
</div>

<style module>
  .timer {
    display: flex;
    height: 4px;

    background: #4c4c4c; /* Fallback for older browsers */
    background: var(--slider-bar-color);
  }

  .timer__value {
    background: #f0f0f0; /* Fallback for older browsers */
    background: var(--slider-track-color);

    width: 0;
    max-width: 100%;
    height: 100%;
    overflow: hidden;
    white-space: nowrap;
    color: transparent;
  }

  @media (prefers-contrast: more) {
    .timer {
      background-color: #4c4c4c;
    }
  }
</style>
